import { useState, useTransition } from "react";
import { DeleteDiv, DeleteButton } from "./profileStyles";
import { ActivityTextSection } from "../../styledComponents/members";
import { CommonText } from "../../styledComponents/common";
import { ColoredButton } from "../../styledComponents/buttons";

import UserProfileDeleteModal from "./UserProfileDeleteModal";
import { useTranslation } from 'react-i18next'


const UserDeleteProfile = (props) => {
  const [showDeleteAccountState, setshowDeleteAccountState] = useState(false);

  const {t} = useTranslation();
  const showDeleteModal = () => {
    setshowDeleteAccountState(true);
  };
  const toggle = () => {
    setshowDeleteAccountState(!showDeleteAccountState);
  };
  const deleteAccount = (password, agreed, feedBack) => {
    props.profileDelete({
      password: password,
      agreed: agreed,
      feedback: feedBack,
    });
    setshowDeleteAccountState(false);
  };
  return (
    <>
      <UserProfileDeleteModal
        isOpen={showDeleteAccountState}
        toggle={toggle}
        deleteAccount={deleteAccount}
      />
      <DeleteDiv>
        <ActivityTextSection>
          <CommonText fontSize="16px" title>
            {t('delete_account?')}
          </CommonText>
          <CommonText $label fontWeight="500">
            {t('your_account_deletion_request_will_be_processed_after_7_days')}
          </CommonText>
        </ActivityTextSection>
        <ColoredButton type="delete" onClick={() => showDeleteModal()}>
          {t('delete_account')}
        </ColoredButton>
      </DeleteDiv>
    </>
  );
};
export default UserDeleteProfile;
